import React, { useEffect, useState } from "react"
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import db from "../../../../db"
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton'
import { toast } from 'react-toastify';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 80,
        width: "-webkit-fill-available"
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    root: {},
    content: {
        padding: 0
    },
    inner: {
        minWidth: 1050
    },
    nameContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    actions: {
        justifyContent: 'flex-end'
    }
}));

function FormDialogView(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const { op, setOp, title, func, fields, sizes } = props


    useEffect(() => {
        setOpen(op)
        console.log(fields);
    }, [op])


    const handleClose = () => {
        setOpen(false);
        setOp(false)
    };





    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title"
                fullScreen >
                <DialogTitle id="form-dialog-title"><b>{title}</b></DialogTitle>
                <DialogContent>
                    {fields ? <div>
                        <div style={{ "display": "flex" }}>
                            < TextField
                                disabled
                                margin="dense"
                                label="Պատվերի համար"
                                type="text"
                                fullWidth
                                value={fields.orderNumber}
                            />
                            < TextField
                                disabled
                                margin="dense"
                                label="Ընդունման ամսաթիվ"
                                type="date"
                                format="dd/MM/yyyy"
                                fullWidth
                                value={fields.orderDate}
                            />
                            < TextField
                                disabled
                                margin="dense"
                                label="Կատարման ամսաթիվ"
                                type="date"
                                format="dd/MM/yyyy"
                                fullWidth
                                value={fields.deadline}
                            />
                        </div>
                        <div style={{ "display": "flex" }}>
                            < TextField
                                disabled
                                margin="dense"
                                label="Պատվիրատու"
                                type="text"
                                fullWidth
                                value={fields.customer}
                            />
                            < TextField
                                disabled
                                margin="dense"
                                label="Կարճ կոդ"
                                type="text"
                                fullWidth
                                value={fields.shortCode}
                            />
                        </div>
                        <div style={{ "display": "flex" }}>
                            < TextField
                                disabled
                                margin="dense"
                                label="Մոդել"
                                type="text"
                                fullWidth
                                value={fields.model}
                            />
                            < TextField
                                disabled
                                margin="dense"
                                label="Երկիր"
                                type="text"
                                fullWidth
                                value={fields.country}
                            />
                        </div> </div> : <></>}
                    {fields ?
                        <div>
                            {fields.startOrders.map((i, ind) => (
                                <Table style={{ "marginBottom": "15px" }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Նկարագրություն</TableCell>
                                            <TableCell>Ամսաթիվ</TableCell>
                                            <TableCell>Տարբերակ</TableCell>
                                            <TableCell>Գույն</TableCell>
                                            <TableCell>{sizes.option1}</TableCell>
                                            <TableCell>{sizes.option2}</TableCell>
                                            <TableCell>{sizes.option3}</TableCell>
                                            <TableCell>{sizes.option4}</TableCell>
                                            <TableCell>{sizes.option5}</TableCell>
                                            <TableCell>{sizes.option6}</TableCell>
                                            <TableCell>{sizes.option7}</TableCell>
                                            <TableCell>{sizes.option8}</TableCell>
                                            <TableCell>{sizes.option9}</TableCell>
                                            <TableCell>{sizes.option10}</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Սկզբնական պատվեր</TableCell>
                                            <TableCell>{i.startDate}</TableCell>
                                            <TableCell>{i.productOption}</TableCell>
                                            <TableCell>{i.color}</TableCell>
                                            <TableCell>{i.option1}</TableCell>
                                            <TableCell>{i.option2}</TableCell>
                                            <TableCell>{i.option3}</TableCell>
                                            <TableCell>{i.option4}</TableCell>
                                            <TableCell>{i.option5}</TableCell>
                                            <TableCell>{i.option6}</TableCell>
                                            <TableCell>{i.option7}</TableCell>
                                            <TableCell>{i.option8}</TableCell>
                                            <TableCell>{i.option9}</TableCell>
                                            <TableCell>{i.option10}</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>

                                        {fields.canceledOrders && fields.canceledOrders[ind] ? <div style={{ "display": "contents" }}>
                                            {Object.keys(fields.canceledOrders[ind]).map(j => (
                                                <TableRow>
                                                    <TableCell>Չեղարկում</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].cancelDate}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].productOption}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].color}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option1}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option2}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option3}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option4}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option5}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option6}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option7}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option8}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option9}</TableCell>
                                                    <TableCell>{fields.canceledOrders[ind][j].option10}</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            ))}
                                        </div> : <></>}
                                        <TableRow>
                                            <TableCell>Ընդամենը</TableCell>
                                            <TableCell></TableCell>
                                            <TableCell>{fields.finalOrders[ind].productOption}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].color}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option1}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option2}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option3}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option4}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option5}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option6}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option7}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option8}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option9}</TableCell>
                                            <TableCell>{fields.finalOrders[ind].option10}</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            ))}

                        </div> : <></>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Չեղարկել
          </Button>
                    <Button onClick={func} color="primary">
                        Հաստատել
          </Button>
                </DialogActions>



            </Dialog>
        </div >
    );
}

export default FormDialogView